/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import './ProgramCard.scss';

const ProgramCard = ({ id, speakers = [], tileRole, talk, color, onCardClick, selectedTalk }) => {
  const history = useHistory();
  const cardRef = useRef(null);
  const talkExist = Object.entries(talk).length > 0;

  const onTalkClick = (e, talkId) => {
    if (
      id &&
      history.location.pathname === '/program' &&
      e.target.id !== 'video-link' &&
      tileRole !== 'CLOSED'
    ) {
      onCardClick(talkId);
    }
    if (id && e.target.id !== 'video-link' && tileRole !== 'CLOSED') {
      history.push(`/program/${talkId}`);
    }
  };

  useEffect(() => {
    if (
      history.location.pathname === '/program' &&
      selectedTalk &&
      selectedTalk === id &&
      cardRef.current
    ) {
      window.scrollTo(0, cardRef.current.offsetTop - 10);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={cardRef} id="program-card">
      <div
        className={`card ${
          Object.entries(talk).length === 0 || !id || tileRole === 'CLOSED' ? 'not-clickable' : ''
        } ${tileRole === 'CLOSED' ? 'closed' : ''}`}
        onClick={talkExist ? e => onTalkClick(e, id) : undefined}>
        <div className={`card-color-marker track-${color}-color`} />
        <div className="card-content">
          {talkExist ? (
            <>
              <p className="program-card-top-row">{talk.title || tileRole}</p>
              <div className="program-card-speakers">
                {speakers.map(speaker => (
                  <div key={speaker.id || speaker.name} className="speakers">
                    <div>{speaker.name}</div>
                    <div className="speakers-company">
                      {speaker.company === '---'
                        ? speaker.country
                        : `${speaker.company} - ${speaker.country}`}
                    </div>
                  </div>
                ))}
                {talk.youtube ? (
                  <a href={talk.youtube} id="video-link" rel="noopener noreferrer" target="_blank">
                    <i className="fab fa-youtube-square fa-2x video" id="video-link" /> Recording
                  </a>
                ) : null}
              </div>
              <div className="bottom-part">
                {history.location.pathname.includes('/speakers') ? (
                  <div>
                    <div className="date">
                      {talk.conferenceDay === 'day1' ? 'Oct 19, 2022' : 'Oct 20, 2022'}
                    </div>
                    <div className="time">
                      {talk.startTime} - {talk.endTime}
                    </div>
                  </div>
                ) : null}
                {talk.room ? (
                  <div className="room">
                    <i className={`fa fa-map-marker-alt track-${color} room-icon`} />
                    {talk.room}
                  </div>
                ) : null}
              </div>
            </>
          ) : (
            <div>
              <p className="program-card-top-row">
                <span className="is-full-desktop">{tileRole}</span>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ProgramCard.defaultProps = {
  color: '',
  id: '',
  onCardClick: () => {},
  selectedTalk: ''
};

ProgramCard.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  onCardClick: PropTypes.func,
  selectedTalk: PropTypes.string,
  speakers: PropTypes.arrayOf(PropTypes.any).isRequired,
  talk: PropTypes.objectOf(PropTypes.any).isRequired,
  tileRole: PropTypes.string.isRequired
};

export default ProgramCard;
